import { Button, Modal } from "antd";
import { DataGrid } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import * as _ from "lodash";
import * as React from "react";
import { useState } from "react";
import { Ispc } from "src/services/interfaces/Compliance/Credito/ISpc";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { formatCurrency } from "src/util/Masks/formatCurrency";

interface ISpcProps {
    spc: Ispc;
}

export const ModalSpcView: React.FC<ISpcProps> = ({
    spc,
}) => {

    const [showModal, setShowModal] = useState(false);

    const detailsGroupByOfficialName: Array<{ offcialName: string, value: number }> =
        spc.occurrences.flatMap((c) => {
            const result = []
            for (const [key, values] of Object.entries(_.groupBy(
                c.details.map((d) =>
                (
                    {
                        value: d.value, officialName: d.issuingCompanies[0].officialName
                    }
                )), 'officialName'))) {
                const r = { officialName: key, value: values.reduce((prev, curr) => prev + curr.value, 0) }
                result.push(r).toFixed(2);
            }
            return result
        }, [])

    const moneyMask = (params: any) => MoneyMask(params.value!);

    return (
        <>
            <div>
                <Button onClick={() => setShowModal(true)}>
                    Detalhes
                </Button>
            </div>
            <Modal className="modal-view-trade-bcheck" title="Detalhes Spc" visible={showModal} footer={[]} onCancel={() => setShowModal(false)}>
                <div className="row">
                    <span className="left description">Divida Total:</span>
                    <span className="right description">{formatCurrency(spc.totalDebts)}</span>
                </div>
                <div className="row" style={{ marginTop: "20px" }}>
                    <DataGrid dataSource={detailsGroupByOfficialName} showBorders columnAutoWidth>
                        <Column caption="Razão Social" alignment={"center"} dataType="string" dataField="officialName" />
                        <Column caption="Valor divida" alignment={"center"} dataType="string" dataField="value" cellRender={moneyMask} />
                    </DataGrid>
                </div>
            </Modal >
        </>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/BcheckView/ModalSpcView.tsx